import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { TailWrapper, StyledTriangleSvg, TriangleClippingDiv } from './styles.js';

/**
 * BackTriangle
 */

const BackTriangle = ({
  fill,
  width,
  side,
  shadow
}) => jsx(TriangleClippingDiv, Object.assign({
  shadow: shadow,
  side: side
}, {
  children: jsx(StyledTriangleSvg, {
    fill: fill,
    isBackTriangle: true,
    shadow: shadow,
    side: side,
    width: width
  }, void 0)
}), void 0);

BackTriangle.displayName = 'BackTriangle';
/**
 * PopoverTail
 */

const PopoverTail = forwardRef(({
  fill,
  borderColor,
  side,
  width,
  offset,
  offsetSide,
  shadow
}, ref) => jsxs(TailWrapper, Object.assign({
  "aria-hidden": "true",
  offset: offset,
  offsetSide: offsetSide,
  ref: ref,
  side: side,
  width: width
}, {
  children: [jsx(BackTriangle, {
    fill: borderColor,
    shadow: shadow,
    side: side,
    width: width
  }, void 0), jsx(StyledTriangleSvg, {
    fill: fill,
    side: side,
    width: width
  }, void 0)]
}), void 0));
PopoverTail.displayName = 'PopoverTail';

export { PopoverTail };
